import { render, staticRenderFns } from "./AgentCustomers.vue?vue&type=template&id=13f80afa&"
import script from "./AgentCustomers.vue?vue&type=script&lang=js&"
export * from "./AgentCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports